import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("token", data.token);
    // Clear any stale per-user cache from a previous user so the new user
    // never inherits their profile photo / PWA identity.
    const prevEmail = (() => {
      try { return (JSON.parse(localStorage.getItem("hassein.pwa.identity") || "{}").email || "").toLowerCase(); }
      catch { return ""; }
    })();
    if (prevEmail && prevEmail !== (email || "").toLowerCase()) {
      localStorage.removeItem("hassein.pwa.identity");
    }
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // ignore logout errors
    }
    localStorage.removeItem("token");
    localStorage.removeItem("hassein.pwa.identity");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, refresh: check, setSession: setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
